import React, { useCallback, useEffect, useRef, useState } from "react";
import InventoryDetails from "../components/InventoryDetails";
import Space from "../ui/Space";
import InventoryHistory from "../components/InventoryHistory";
//import { search } from "../temp";
import InventoryList from "../components/InventoryList";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Nav from "../ui/Nav";
import { createModal } from "../hooks/createModal";
import InventorySearch from "../popups/InventorySearch";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import InventoryIndex from "../popups/InventoryIndex";
import InventoryMessage from "../popups/InventoryMessage";
import { convertDiscountToInt, diffObjs, getEnum, getEnumLabel, istl, kbdEvent, requestPrompt, runEvent, showOptions } from "../utils/Utils";
import InventoryAdjust from "../popups/InventoryAdjust";
import InventoryPubstock from "../components/InventoryPubstock";
import Confirm from "../popups/Confirm";
import Divider from "../ui/Divider";
import { stock_structure } from "../data_structures/Stock";
import InventoryExtra from "../popups/InventoryExtra";
import Tabs from "../ui/Tabs";
import { drawPicker } from "../popovers/Picker";
import InventoryReserve from "../components/InventoryReserve";
import Cookies from "js-cookie";
import ReportsInventoryList from "../components/ReportsInventoryList";
import { ENUMS } from "../utils/Enums";
import OrderForm from "../components/OrderForm";
import InventoryOrders2 from "../components/InventoryOrders2";
import InventoryOrder from "../components/InventoryOrder";
import InventoryReserveFromStock from "../components/InventoryReserveFromStock";

export default function InventoryController(props) {


    const { signal = {}, search = false, controller = "", setController = () => { }, is_modal = false, is_global = false, callback = () => { }, route = ROUTES.INVENTORY.INVENTORY } = props;
    const [loading, setLoading] = useState(false);
    const [extrasLoading, setExtrasLoading] = useState(false)
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [conditionSelected, setConditionSelected] = useState(false);
    const [fullData, setFullData] = useState({});
    const [filters, setFilters] = useState({ sort: "id", limit: 45, dynamic: true, localSort: "stock_id", pubstock: false, type: "default" });
    const [align, setAlign] = useState("auto");
    const [gridLoading, setGridLoading] = useState(false);
    const [goto, setGoto] = useState(false)
    const gridType = useRef("");

    const expand = false;

    const history_filters = {
        adjustment: true,
        held: true,
        orders: true,
        orders: true,
        prepay: true,
        quotes: false,
        returns: true,
        sales: true,
        transfers: true
    }
    const [historyFilters, setHistoryFilters] = useState(history_filters);


    const cycleGridType = () => {

        if (gridLoading) {
            return;
        }

        let _g = gridType.current || "";
        if (_g === "") {
            _g = "weekly";
        } else if (_g === "weekly") {
            _g = "daily";
        } else {
            _g = ""
        }
        gridType.current = _g;
    }

    const drawReportResultsString = () => {
        const { order_1, order_2, order_3, cached_row_total } = is_modal;

        const order = [
            order_1 ? getEnumLabel(ENUMS.REPORTS_INDEX, order_1) : "Enter date",
            order_2 && getEnumLabel(ENUMS.REPORTS_INDEX, order_2),
            order_3 && getEnumLabel(ENUMS.REPORTS_INDEX, order_3)
        ].filter(Boolean);

        return (
            <>
                Showing: <span className="text-light">#{selected?.number} of {cached_row_total}</span> records, ordered by <span style={{ color: "var(--text-yellow)" }}>{order.join(", ")}</span>
            </>
        );
    };

    const keywordTerm = useRef(false);
    const [searchMsg, setSearchMsg] = useState((!is_modal) ? "Search results" : "");
    const [state, setState] = useState({
        view: (is_modal) ? "inventory_full" : "inventory",
        edit: false,
        new: false,
        copy: false,
        history_checked: false,
        tabs: "history",
        pubstock: Cookies.get("pubstock_state") || "min"
    })




    const [isTitleLink, setIsTitleLink] = useState(false);
    const in_stock = (selected?.stock_id && istl(selected)) ? false : true;

    const refs = useRef([])


    const addOrder = () => {
        const event = new CustomEvent("addOrder", { detail: {} });
        window.dispatchEvent(event);
    }


    const switchView = (_state = "inventory", tabs = false) => {

        if (extrasLoading) {
            return;
        }


        switch (_state) {
            case "inventory":
                window.bm_state.value = route;
                break;
            case "inventory_full":
                window.bm_state.value = route;
                break;
            case "history":
                window.bm_state.value = ROUTES.INVENTORY.HISTORY;
                break;
            case "history_full":
                _state = "history";
                window.bm_state.value = ROUTES.INVENTORY.HISTORY;
                break;
            case "orders":
                window.bm_state.value = ROUTES.INVENTORY.ORDERS;
                break;
        }




        setState({ ...state, "view": _state, tabs: (tabs) ? tabs : state.tabs })
    };

    //TEMP
    // useEffect(() => {

    //     setTimeout(() => {
    //          switchView("orders")
    //     }, 100)

    // }, [])

    const switchEdit = () => {
        setState(prevState => {
            if (!prevState.edit) {
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                new: false,
                copy: false
            };
        });
    };

    const switchNew = () => {
        setState(prevState => {
            if (!prevState.new) {
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                new: !prevState.new
            };
        });
    };

    const switchCopy = () => {
        setState(prevState => {
            if (!prevState.new) {
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                copy: !prevState.copy,
                new: !prevState.new
            };
        });

    }


    const updateRow = (_data, _stock_id, diff = false) => {
        let _d = [...data];
        let _f = _d.findIndex(item => item.stock_id === _stock_id);
        if (_f > -1) {

            if (diff) {
                if (diffObjs(_d[_f], _data, ['available_on_hand', 'on_order', 'price', 'binding', 'title', 'author', 'supplier_1', 'class', 'primary_code', 'pubstock'])) {
                    _d[_f] = _data;
                    setData(_d);
                    setSelected(_data);
                }
            } else {
                _d[_f] = _data;
                setData(_d);
                setSelected(_data);
            }

        }
    }

    useEffect(() => { window.bm_state.value = route }, []);

    const selectedRef = useRef(selected);
    const timeoutRef = useRef(null);
    const pendingRef = useRef(null);
    const lastRunRef = useRef(null);
    const requestIdRef = useRef(0);

    //   adjustment: true,
    //         held: true,
    //         orders: true,
    //         orders: true,
    //         prepay: true,
    //         quotes: false,
    //         returns: true,
    //         sales: true,
    //         transfers: true


    const runFetch = useCallback((_selected, extras = { want_other_conditions: true, want_pending_orders: true, want_pubstock: true, want_history: true }) => {
        const id = ++requestIdRef.current;
        setGridLoading(true);
        pubCall("stock.getSingleExtras", {
            stock_id: _selected.stock_id,
            grid_type: gridType.current,
            want_other_conditions: extras?.want_other_conditions,
            want_pending_orders: extras?.want_pending_orders,
            want_pubstock: extras?.want_pubstock,
            want_history: extras?.want_pubstock,
            only_recent: true,
            adjustment: historyFilters.adjustment,
            held: historyFilters.held,
            orders: historyFilters.orders,
            prepay: historyFilters.prepay,
            quotes: historyFilters.quotes,
            returns: historyFilters.returns,
            transfers: historyFilters.transfers,
            sales: historyFilters.sales
        }, (_s, _r) => {
            if (id !== requestIdRef.current) {
                setExtrasLoading(false);
                return;
            };
            setExtrasLoading(false);
            setGridLoading(false);
            if (_s) {
                if (!extras) {
                    setFullData({ ...fullData, "grid_info": _r.grid_info })
                }
                setFullData(_r);
                if (_r?.stock) {
                    setData(prev => prev.map(item => item.stock_id === _r.stock.stock_id ? { ...item, ..._r.stock } : item));
                }
            } else {
                showError(_r);
            }
        }
        );
    }, [historyFilters]);

    const fetchExtra = useCallback((_selected = selected) => {


        setFullData({});
        selectedRef.current = _selected;
        setConditionSelected(false);

        // don't fetch if no stock id
        if (!_selected?.stock_id || _selected.stock_id.substr(0, 8) === "no-stock") {


            if (!_selected?.title_link?.primary_code) {
                return;
            }

            pubCall("title.getPubstock", { primary_code: _selected?.title_link?.primary_code }, (_s, _r) => {
                if (_s) {

                    setFullData({ pubstock: _r });
                    setExtrasLoading(false);

                } else {
                    setFullData({});
                    setExtrasLoading(false);
                }
            })

            return;
        }

        Cookies.set("inventory_stock_id", _selected.stock_id);
        if (!timeoutRef.current) {
            setExtrasLoading(true);
            runFetch(_selected);
            lastRunRef.current = _selected;
        }
        pendingRef.current = _selected;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            const toRun = pendingRef.current;
            if (toRun && toRun.stock_id !== lastRunRef.current?.stock_id) {
                setExtrasLoading(true);
                runFetch(toRun);
                lastRunRef.current = toRun;
            }
            timeoutRef.current = null;
            pendingRef.current = null;
        }, 300);
    }, [selected, runFetch]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);


    useEffect(fetchExtra, [selected])


    const fetchKeywordNext = (e) => {

        if (!keywordTerm?.current === false) {
            return;
        }
        pubCall("stock.searchKeyword", { limit: 45, offset: data.length, keyword: keywordTerm.current }, (_s, _r) => {
            if (_s) {
                let _combined = data.concat(_r.rows);
                if (_r.rows.length < 45 || _combined.length === _r.total) {
                    keywordTerm.current = false;
                }
                setData(data.concat(_r.rows));
            }
        })
    }

    useEffect(() => {
        const onExtra = (e) => { fetchExtra(); };
        const onKewordNext = (e) => { fetchKeywordNext(e.detail) }
        window.addEventListener("callKeywordNext", onKewordNext);
        window.addEventListener("callExtra", onExtra);
        return () => {
            window.removeEventListener("callKeywordNext", onKewordNext)
            window.removeEventListener("callExtra", onExtra)
        };
    }, [selected, data]);

    const showMessageNote = () => {
        window.bm_state.value = ROUTES.INVENTORY.MESSAGE;
        createModal({ component: <InventoryMessage controller={controller} stock_id={selected?.stock_id} route={ROUTES.INVENTORY.MESSAGE} />, closable: true, title: "Inventory Notes", callback: () => { window.bm_state.value = route; } })
    }


    useEffect(() => {

        if (search) {
            onSearch(search?.results, search?.message)
        }

    }, [])

    const onSearch = (e, _searchMsg) => {
        const { type = "", message = "", term = "" } = (e) ? e : {};

        if (message) {
            setSearchMsg(message)
        }


        if (type !== "title_link") {
            setIsTitleLink(false);
        }

        switch (type.toLowerCase()) {

            case "title_link":
                setAlign("start");
                setFilters({ ...filters, "dynamic": false, type: "title_link" })
                setData(e.data);
                setSelected(e.data.length > 0 ? e.data[0] : {});
                setIsTitleLink(true);
                break;

            case "keyword":
                keywordTerm.current = term;
                setFilters({ ...filters, "dynamic": false, "sort": "id", localSort: "init", type: "keyword" })
                setData(e.data.rows);
                setSelected(e.data.rows.length > 0 ? e.data.rows[0] : {})
                break;
            case "title":
                if (e.data.rows_previous.length > 0) { setAlign("start"); }
                setFilters({ ...filters, "sort": "title", "dynamic": true, type: "title" })
                setData(e.data.rows_previous.concat(e.data.rows_next));
                setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                break;
            case "isbn":
                if (e.data.rows_previous.length > 0) { setAlign("start"); }
                setFilters({ ...filters, "sort": "isbn", "dynamic": true, type: "isbn" })
                setData(e.data.rows_previous.concat(e.data.rows_next));
                setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                break;
            case "author":
                if (e.data.rows_previous.length > 0) { setAlign("start"); }
                setFilters({ ...filters, "sort": "author", "dynamic": true, type: "author" })
                setData(e.data.rows_previous.concat(e.data.rows_next));
                setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                break;
            case "supplier":
                if (e.data.rows_previous.length > 0) { setAlign("start"); }
                setFilters({ ...filters, "sort": "supplier", "dynamic": true, type: "supplier" })
                setData(e.data.rows_previous.concat(e.data.rows_next));
                setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                break;
            case "class":
                if (e.data.rows_previous.length > 0) { setAlign("start"); }
                setFilters({ ...filters, "sort": "class", "dynamic": true, type: "class" })
                setData(e.data.rows_previous.concat(e.data.rows_next));
                setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                break;
            case "upc":
                if (e.data.rows_previous.length > 0) { setAlign("start"); }
                setFilters({ ...filters, "sort": "upc", "dynamic": true, type: "upc" })
                setData(e.data.rows_previous.concat(e.data.rows_next));
                setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                break;
        }

    }

    const showSearch = () => {
        window.bm_state.value = ROUTES.INVENTORY.SEARCH;
        createModal({
            component: <InventorySearch controller={controller} setStock={setSelected} selected={selected} route={ROUTES.INVENTORY.SEARCH} />, closable: true, title: "Product Search",
            callback: (e, _searchMsg) => {
                onSearch(e, _searchMsg);
                window.bm_state.value = route
            }
        });
    }

    const showSort = () => {
        window.bm_state.value = ROUTES.INVENTORY.SORT;
        createModal({
            component: <InventoryIndex sort={filters.sort} route={ROUTES.INVENTORY.SORT} />, closable: true, title: "Sort",
            callback: (_sort) => {
                window.bm_state.value = route;
                if (_sort) { setFilters({ ...filters, "sort": _sort, "dynamic": true }); }
            }
        });
    }

    const pickReserve = () => {
        

        drawPicker({
            controller: controller,
            value: "Pend", title: "Reserve for customer", closeable: true, show_keys: true, allow_keys: true, height: 300, route: route, close: () => { }, callback: (e) => {
                if (e) {

                    if (e === "inventory") {
                        // Pull from Inventory
                        if (!selected?.available_on_hand) {

                            if (Cookies.get("hold_without_inventory")) {
                                // Bypass...
                                showReserveFromStock();
                                return;
                            } else {
                                showMessage("[TODO] - REQUIRES POS")
                                return; 
                                setTimeout(() => {
                                    showOptions({
                                        controller: controller,
                                        menu: [{ label: "Yes", key: "yes", value: "yes" }, { label: "No", key: "no", value: "no" }, { label: "Don't ask", key: "dont", value: "dont" }],
                                        start_index: 0,
                                        closeable: false,
                                        route: window.bm_state.value,
                                        description: <div style={{ "textAlign": "center" }}>You do not have stock.<br />Are you sure you want a Held sale for copies you do not have?</div>,
                                        title: "Warning",
                                        callback: (e) => {
                                            switch (e) {
                                                case "no":
                                                    alert("what to do here?")
                                                    break;
                                                case "dont":
                                                    Cookies.set("hold_without_inventory", true)
                                                    // yes then don't ask
                                                    showReserveFromStock();
                                                    break;
                                                default: // yes
                                                    showReserveFromStock();
                                                    break
                                            }
                                        }
                                    })
                                }, 0)

                            }



                        } else {

                        }



                    } else {
                        // Special Order
                        showReserve();
                    }
                }
            }, offset: [0, 10],
            options: [
                { value: "special_order", label: "Order: Special order it for customer", key: KBD.O },
                { value: "inventory", label: (selected?.available_on_hand) ? `Inventory: Grab it from  ${selected?.available_on_hand} copies on the shelf` : "No copies available on hand (order instead?)", key: KBD.I }
            ]
        })

    }


    const showReserveFromStock = () => {

        window.bm_state.value = ROUTES.INVENTORY.RESERVE;
        createModal({
            component: <InventoryReserveFromStock
                updateSellPrice={updateSellPrice}
                fetchExtra={fetchExtra}
                controller={controller}
                signal={signal}
                switchView={switchView}
                sell_price={fullData?.stock?.price}
                setFullData={setFullData}
                fullData={fullData}
                callback={() => {
                    switchView("inventory")
                }}
                primary_code={selected?.primary_code}
                condition_code={selected?.condition_code} />,
            closable: true,
            title: "Inventory Reservation (Pull Stock for Customer)",
            callback: (_stock) => {
                if (_stock) {
                    updateRow(_stock, _stock.stock_id);
                }
                window.bm_state.value = route;
            }
        });

    }

    const showReserve = () => {

        window.bm_state.value = ROUTES.INVENTORY.RESERVE;
        createModal({
            component: <InventoryReserve
                updateSellPrice={updateSellPrice}
                fetchExtra={fetchExtra}
                controller={controller}
                signal={signal}
                switchView={switchView}
                sell_price={fullData?.stock?.price}
                setFullData={setFullData}
                fullData={fullData}
                callback={() => {
                    switchView("inventory")
                }}
                primary_code={selected?.primary_code}
                condition_code={selected?.condition_code} />,
            closable: true,
            title: "New Customer Order or Pull From an Existing Order ",
            callback: (_stock) => {
                if (_stock) {
                    updateRow(_stock, _stock.stock_id);
                }
                window.bm_state.value = route;
            }
        });

    }

    const showExtra = () => {
        window.bm_state.value = ROUTES.INVENTORY.EXTRA;
        createModal({
            component: <InventoryExtra signal={signal} route={ROUTES.INVENTORY.EXTRA} />, closable: true, title: "Xtra Options",
            callback: (_type) => {
                window.bm_state.value = route;
            }
        });
    }


    const close = () => {

        // Close title link...
        if (isTitleLink) {
            setIsTitleLink(false);
            setFilters({ ...filters, "dynamic": true });
        } else {
            // Close inventory...
            alert("close")
        }

    }




    const showAdjust = () => {
        window.bm_state.value = ROUTES.INVENTORY.ADJUST;
        createModal({
            component: <InventoryAdjust signal={signal} stock_data={selected} sort={filters.sort} route={ROUTES.INVENTORY.ADJUST} />, closable: true, title: "Adjust Quantities / Keywords ",
            callback: (_stock) => {
                if (_stock) {
                    updateRow(_stock, _stock.stock_id);
                }
                window.bm_state.value = route;
            }
        });
    }


    const togglePubstock = (_set = null) => {

        let _s = state.pubstock;
        if (state?.pubstock === "") {
            _s = "min"
        } else if (state?.pubstock === "min") {
            _s = "full"
        } else {
            _s = "";
        }

        if (_set !== null) {
            _s = _set;
        }


        Cookies.set("pubstock_state", _s);
        setState({ ...state, "pubstock": _s })
    }

    const deleteRow = () => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} events={[KBD.D, KBD.U]} title={"Delete Inventory Card?"} signal={signal} route={ROUTES.HELPERS.CONFIRM} />, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    pubCall("stock.delete", { stock_id: selected.stock_id }, (_s, _r) => {
                        if (_s) {
                            // shift selected down, or up
                            let _f = data.findIndex(item => item.stock_id === selected.stock_id);
                            if (data.length > _f - 1) { setSelected(data[_f + 1]); }
                            else if (data.length > 0) { setSelected(data[_f - 1]); }
                            else { setSelected({}) }
                            // remove from data
                            setData(data.filter(item => item.stock_id !== selected.stock_id));
                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }

    const showWeb = () => {
        if (selected?.primary_code) {
            window.open(`https://biz.bookmanager.com/purchasing/browse/filter/t/${selected?.primary_code}`)
        }
    }

    const showGoto = () => {
        requestPrompt({
            route: route, width: 0, title: "Go to Record #", inputProps: { number: true, style: { "textAlign": "left" }, width: 100 }, width: 50, callback: (e) => {
                if (e) {
                    setGoto(e)
                }
            }
        })
    }





    const inventory_nav = [


        { key: KBD.Digit0, action: () => { setController("reports") } },
        {
            key: KBD.ESCAPE, action: () => {
                if (is_modal || is_global) {
                    callback();
                } else {
                    setController("home")
                }
            }
        },
        { key: KBD.SLASH, action: () => { { cycleGridType(); runFetch(selected) } } },
        { key: KBD.TAB, action: () => (state?.tabs === "history") ? setState({ ...state, "tabs": "orders" }) : setState({ ...state, "tabs": "history" }) },
        { key: KBD.A, text: "Adj", action: () => showAdjust() },
        { key: KBD.C, text: "Cpy", action: () => switchCopy() },
        { key: KBD.D, text: "Del", action: () => deleteRow() },
        { key: KBD.ARROW_RIGHT, action: () => { (state.view === "inventory_full") ? switchView("inventory") : (state.tabs === "orders") ? setState({ ...state, "tabs": "orders" }) : switchView("history", "history") } },
        { key: KBD.ARROW_LEFT, action: () => (state.tabs === "orders") ? switchView("history", "history") : switchView("inventory_full") },
        { key: KBD.E, text: "Edt", action: switchEdit },
        { key: KBD.H, text: "Hst", action: () => switchView("history", "history") },
        { key: KBD.I, text: "Indx", action: showSort },
        { text: "Lbl" },
        { key: KBD.M, text: "Msg", action: showMessageNote },
        { key: KBD.N, text: "New", action: switchNew },
        {
            key: KBD.O, text: "Ord", action: () => { switchView("orders", "orders") }
        },
        { key: KBD.R, text: "Rsv", action: pickReserve },
        { key: KBD.S, text: "Srch", action: () => { showSearch() } },
        { text: "Trf" },
        { text: "View" },
        { key: KBD.W, text: "Web", action: showWeb },
        { key: KBD.X, text: "Xtra", action: showExtra },
        { text: "Ytag" },
        // {
        //     key: KBD.T,
        //     text: "Test", action: () => {
        //         runEvent("callOrder", { test: "test" }, (e) => {
        //             alert(e)
        //         })
        //     }
        // },

        { key: KBD.COMMA, text: ", Pubstock", right: true, action: () => togglePubstock() },
        { text: ". Multistore", right: true },
    ]

    const reports_nav = [
        { key: KBD.ESCAPE, action: () => { callback() } },
        { key: KBD.Digit2, action: () => { callback(false); setController("inventory") } },
        { key: KBD.ARROW_RIGHT, action: () => { (state.view === "inventory_full") ? switchView("inventory") : (state.tabs === "orders") ? setState({ ...state, "tabs": "orders" }) : switchView("history", "history") } },
        { key: KBD.ARROW_LEFT, action: () => (state.tabs === "orders") ? switchView("history", "history") : switchView("inventory_full") },
        { key: KBD.TAB, action: () => (state?.tabs === "history") ? setState({ ...state, "tabs": "orders" }) : setState({ ...state, "tabs": "history" }) },
        { key: KBD.SLASH, action: () => { { cycleGridType(); runFetch(selected) } } },
        { key: KBD.A, text: "Adj", action: () => showAdjust() },
        { key: KBD.G, text: "Go to", action: () => { showGoto() } },
        { key: KBD.D, text: "Del", action: () => deleteRow() },
        { key: KBD.E, text: "Edt", action: switchEdit },
        //   { key: KBD.ARROW_RIGHT, action: () => { (state.view === "inventory_full") ? switchView("inventory") : switchView("history") } },
        // { key: KBD.ARROW_LEFT, action: () => switchView("inventory_full") },
        { key: KBD.H, text: "Hst", action: () => switchView("history", "history") },
        { text: "Lbl" },
        { key: KBD.M, text: "Msg", action: showMessageNote },
        {
            key: KBD.O, text: "Ord", action: () => {
                switchView("orders", "orders")
            }
        },

        { text: "Prt" },
        { text: "Qsls" },
        { key: KBD.R, text: "Rsv", action: pickReserve },
        { text: "Srch" },
        { text: "Ttl" },
        { text: "View" },
        { key: KBD.X, text: "Xtra", action: showExtra },
        { text: "Ytag" },
        { text: "Zrtn" },
        { key: KBD.COMMA, text: ", Pubstock", right: true, action: () => togglePubstock() },
    ]

    const nav = (is_modal) ? reports_nav : inventory_nav;


    useEffect(() => {
        const cleanup = listen(controller, route, nav, false, [], [], [], null);
        return cleanup;
    }, [nav, state])


    const getStockData = () => {

        if (state.new) {

            if (state.copy) {
                return { ...selected, "stock_id": "" }
            }

            return { ...stock_structure }
        }
        if (selected) {

            if (conditionSelected) {
                return conditionSelected?.stock;
            }

            if (!in_stock) {
                return { ...selected.title_link, stock_id: selected.stock_id }
            } else {
                if (fullData.stock?.stock_id === selected?.stock_id) {
                    return fullData.stock;
                }
                return { ...selected }
            }
        } else {
            return {}
        }
    }

    const filterLocal = (_data, _filters = filters) => {

        if (_filters.dynamic) {
            return _data;
        } else {
            return _data;

            let _s = _filters.localSort;
            return _data.sort((a, b) => {
                if (a[_s] < b[_s]) {
                    return -1;
                }
                if (a[_s] > b[_s]) {
                    return 1;
                }
                return 0;
            })
        }
    }


    const toggleHistory = () => {
        setState(prev => ({
            ...prev,
            history_checked: !prev.history_checked
        }));
    };

    const handleTabChange = (tabId) => {

        let _view = state.view;



        if (tabId === "history" && window.bm_state.value === ROUTES.INVENTORY.ORDERS) {
            switchView("inventory")
            setState(prev => ({ ...prev, tabs: tabId, view: _view }));
        }
        else if (tabId === "orders" && window.bm_state.value === ROUTES.INVENTORY.HISTORY) {
            switchView("inventory")
        }
        else {
            setState(prev => ({ ...prev, tabs: tabId, view: _view }));
        }


    };


    const updateSellPrice = (_sell_price) => {

        const _stock_data = { ...fullData.stock, "price": parseFloat(_sell_price) }
        pubCall("stock.edit", { stock: _stock_data }, (_s, _r) => {
            if (_s) {
                setFullData({ ...fullData, "stock": _r });
                showMessage("Stock price updated.")
            } else {
                showError(_r.error)
            }
        })

    }


    const editOrder = (_history_item) => {

        if (!_history_item?.history_id) {
            showError({ error: "There was an error" })
            return;
        }

        pubCall("order.getInfo", { order_id: _history_item?.history_id }, (_s, _r) => {
            if (_s) {
                window.bm_state.value = ROUTES.INVENTORY.ORDER;
                createModal({
                    component: <InventoryOrder
                        route={ROUTES.INVENTORY.ORDER}
                        updateSellPrice={updateSellPrice}
                        onSave={(e) => {

                        }}
                        onExit={() => {

                        }}
                        onRemove={() => { }}
                        fullData={fullData}
                        controller={controller}
                        order={_r}
                        full={true}
                        sell_price={fullData?.stock?.price}
                        edit={true}
                    />, closable: true, title: "Order",
                    callback: (e) => {
                        window.bm_state.value = route;
                        setTimeout(() => {

                        }, 10)

                    }
                });

            } else {
                showError(_r);
            }
        })
    }

    const tabData = [
        {
            id: "history", label: <>History</>, content:
                <div style={{ "height": "calc(100vh - 451px)", minHeight: "200px", "display": "flex", "flexDirection": "column" }}>
                    <div style={{ "flex": "1", "width": "610px" }}>
                        <InventoryHistory
                            controller={controller}
                            filters={historyFilters}
                            setFilters={setHistoryFilters}
                            onSelectSupplier={(e) => editOrder(e)}
                            togglePubstock={togglePubstock}
                            loading={extrasLoading}
                            fullData={fullData}
                            history={fullData?.history}
                            in_stock={in_stock}
                            route={ROUTES.INVENTORY.HISTORY}
                            view={state.view}
                            switchView={switchView}
                            selected={selected}
                            data={[]}
                        />
                    </div>
                </div>
        },
        {
            id: "orders", label: <>Order</>, content:
                <div style={{ "height": "calc(100vh - 451px)", minHeight: "200px", "display": "flex", "flexDirection": "column" }}>
                    <div style={{ "flex": "1", "width": "610px", "backgroundColor": "var(--card-bg)" }}>


                        <InventoryOrders2
                        
                            controller={controller}
                            fetchExtra={fetchExtra}
                            updateSellPrice={updateSellPrice}
                            conditionSelected={conditionSelected}
                            setConditionSelected={setConditionSelected}
                            togglePubstock={togglePubstock}
                            filters={filters}
                            setFilters={setFilters}
                            setSelected={setSelected}
                            loading={extrasLoading}
                            other_conditions={fullData.other_conditions}
                            selected={selected}
                            setFullData={setFullData}
                            getExt
                            fullData={fullData}
                            signal={signal}
                            cost={fullData?.stock?.cost}
                            sell_price={fullData?.stock?.price}
                            state={state}
                            pending_orders={fullData.pending_orders}
                            switchView={switchView}
                            route={ROUTES.INVENTORY.ORDERS}
                            pubstock={<InventoryPubstock
                                onSelectSupplier={(e) => {
                                    addAdditive(e)
                                }}
                                controller={controller}
                                is_order
                                conditionSelected={conditionSelected}
                                setConditionSelected={setConditionSelected}
                                other_conditions={fullData.other_conditions}
                                setState={(e) => togglePubstock(e)}
                                state={state.pubstock}
                                pending_orders={fullData.pending_orders}
                                loading={extrasLoading}
                                pubstock={fullData?.pubstock}
                                selected={selected}
                            />}
                        />


                    </div>
                </div>
        },
    ];


    const addAdditive = (_pubstock) => {

        if (!fullData?.pending_orders?.rows[0] || !_pubstock) {
            // no pending
            showError({ error: "There was an error" });
            return;
        }
        // use pending orders as a template
        let _template = { ...fullData?.pending_orders?.rows[0] };

        // if the supplier is 5 chars, only use the first three 
        _template.supplier = _pubstock?.supplier && _pubstock?.supplier.length === 5 ? _pubstock?.supplier.slice(0, 3) : _pubstock?.supplier;
        _template.invoice_price = parseFloat(_pubstock.supplier_price);
        _template.supplier_discount = convertDiscountToInt(_pubstock.discount);

        // Update price if no TOH
        // if(!fullData?.stock?.total_onhand){
        //     _template.sell_price = parseFloat(_pubstock?.sell_price);
        // }


        pubCall("order.additiveItem", { order_item: _template, require_clerk_code: true }, (_s, _r) => {
            if (_s) {
                showMessage("Order added")
                fetchExtra();
            } else {
                showError(_r);
            }
        })

    }




    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 140px)", minHeight: "511px", gap: "15px" }}>
                <OrderForm />
                <InventoryDetails controller={controller} state={state} gridLoading={gridLoading} setState={setState} setSelected={setSelected} gridType={gridType} grid_info={fullData?.grid_info} signal={signal} in_stock={in_stock} setData={setData} isTitleLink={isTitleLink} updateRow={updateRow} switchEdit={switchEdit} isnew={state.new} edit={state.edit} stock_data={getStockData()} />
                <div onDoubleClick={() => state.edit && kbdEvent(KBD.ESCAPE)}>
                    <div className={(state.edit) ? "dim-overlay" : ""}>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        {(state.view === "reserve" && <div>
                            <InventoryReserve fetchExtra={fetchExtra} controller={controller} signal={signal} switchView={switchView} sell_price={fullData?.stock?.price} setFullData={setFullData} fullData={fullData} callback={() => {
                                switchView("inventory");
                            }} primary_code={selected?.primary_code} condition_code={selected?.condition_code} />

                        </div>)}

                        {(state.view !== "reserve" &&
                            <Space grow style={{ "alignItems": "flex-start", "padding": "0px 15px" }} size={(is_modal && state.tabs === "expand") ? 0 : 15}>

                                {(is_modal) ? <>

                                    <ReportsInventoryList
                                        controller={controller}
                                        header={<>{searchMsg} {(is_modal && !searchMsg && drawReportResultsString())}</>}
                                        report={is_modal}
                                        switchView={switchView}
                                        selected={selected}
                                        setSelected={setSelected}
                                        route={route}
                                        state={state}
                                        setState={setState}
                                        fullData={fullData}
                                        goto={goto}
                                    />

                                </> :

                                    (state.view === "history_full") ? <></> : <InventoryList
                                        controller={controller}
                                        header={<small>{searchMsg} {(is_modal && !searchMsg && drawReportResultsString())}</small>}
                                        filterLocal={filterLocal}
                                        signal={signal}
                                        in_stock={in_stock}
                                        isTitleLink={isTitleLink}
                                        state={state}
                                        view={state.view}
                                        align={align}
                                        setAlign={setAlign}
                                        selected={selected}
                                        setSelected={setSelected}
                                        loading={loading}
                                        setLoading={setLoading}
                                        data={data}
                                        setData={setData}
                                        filters={filters}
                                        setFilters={setFilters}
                                        route={route}
                                        search={search}
                                    />
                                }

                                {((state.tabs !== "expand" && state.view !== "inventory_full") &&


                                    <Tabs
                                        tabData={tabData}
                                        selected={state.tabs}
                                        onChange={(e) => setState({ ...state, tabs: e })}
                                        content_class="empty"
                                    >
                                    </Tabs>



                                    // <div style={{ "height": "calc(100vh - 430px)", minHeight: "220px", "display": "flex", "flexDirection": "column" }}>
                                    //     <div style={{ "flex": "1", "maxWidth": "610px" }}>
                                    //         <Tabs
                                    //             tabData={tabData}
                                    //             selected={state.tabs}
                                    //             onChange={(e) => setState({ ...state, tabs: e })}
                                    //             content={<div>stuff</div>}
                                    //         >

                                    //         </Tabs>




                                    //     </div>
                                    // </div>

                                )}
                            </Space>
                        )}
                        {/* </div> */}

                        {(state.tabs !== "orders" &&
                            <div style={{ "position": "relative", "width": "100%" }}>
                                <div className="shadow" style={{ "position": "absolute", "bottom": "-1px", "right": "15px", "fontSize": "14px" }}>
                                    {(state.pubstock &&
                                        <div ref={(e) => (refs.current["pubstock"] = e)} >
                                            <InventoryPubstock
                                                onSelectSupplier={(e) => {
                                                    addAdditive(e)
                                                }}
                                                controller={controller} conditionSelected={conditionSelected} setConditionSelected={setConditionSelected} other_conditions={fullData.other_conditions} setState={(e) => togglePubstock(e)} state={state.pubstock} pending_orders={fullData.pending_orders} loading={extrasLoading} pubstock={fullData?.pubstock} selected={selected} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}



                    </div>
                </div>
            </div>
            <div className="shim" />
            <Divider />

            <div style={{ 'height': "30px" }}>
                <Space style={{ "padding": "0px 15px" }}>
                    {(((state.view === "inventory" || state.view === "inventory_full") && !state.edit) && <Nav nav={nav} />)}
                </Space>
            </div>
        </div>
    )


}